'use strict';

let requireOrNull = require;
if (!process.env.WEBPACK) {
  requireOrNull = str => str;
}

const {
  critModules: LocalCritModules,
  nonCritModules,
  pageReadyModules,
} = require('../local/js_modules');

const critModules = [
  ...LocalCritModules,
  {
    name: 'BuyButton',
    module: requireOrNull(
      '../../../../modules/buy_button/desktop_2016/frontend/buy_button'
    ),
    featureCheck: serverObj =>
      serverObj.buyButton && !serverObj.usesBuyButtonForm,
  },
  {
    name: 'Variations',
    module: requireOrNull(
      '../../../../modules/variations/frontend/variations-widget'
    ),
    featureCheck: serverObj => serverObj.variations,
  },
];

module.exports = { critModules, nonCritModules, pageReadyModules };
